import { inject, Injectable } from "@angular/core";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class TaxesGuardFF {
	private readonly router = inject(Router);
	private readonly launchDarklyService = inject(LaunchDarklyService);
	public canActivate(): Observable<boolean> {
		return this.launchDarklyService.isActive$(LD_FLAG.TAX_WITHHOLDING).pipe(
			tap((isActive) => {
				if (isActive) {
					return true;
				}
				this.router.navigateByUrl("/home");
				return false;
			})
		);
	}
}
